export default __webpack_public_path__ + "dist/media/Upload-image.00219170.svg";